<template>
	<div class="main">
		<header class="page-title">
			<h2>{{ data.name }}</h2>
			<div class="ml-auto">
				<a @click.prevent="saveTechnical" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="flex box">
			<div class="card six-lg">
				<header class="card-header">
					<h4 class="card-title">General</h4>
				</header>
				<div class="card-body">
					<div class="form-group">
						<label class="label-checkbox">
							<input name="has_popup" type="checkbox" v-model="data.has_popup">
							<span>Has Popup</span>
						</label>
					</div>
					<div class="form-group">
						<label class="label-checkbox">
						<input name="recommended_reading" type="checkbox" v-model="data.recommended_reading">
						<span>Recommended Reading</span>
						</label>
					</div>
				</div>
			</div>
			<div class="card six-lg">
				<header class="card-header">
					<h4 class="card-title">Alternatives</h4>
				</header>
				<div class="card-body">
					<p>When changing the default alternatives make sure you pick all three or it will break the page!</p>
					<div v-for="(alternative, index) in data.alternatives" class="form-group">
						<label :for="'alternative-' + index"></label>
						<select3 :id="'alternative-' + index" :value.sync="data.alternatives[index]" :data="data.providers" :config="selectConfig"></select3>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				required: true
			}
		},
		data() {
			return {
				selectConfig: {
					keyName: 'id',
					valueName: 'name'
				}
			}
		},
		created() {
			let vm = this;

			if (vm.data.alternatives === undefined || vm.data.alternatives.length === 0) {
				vm.data.alternatives = [null, null, null]
			}
		},
		methods: {
			saveTechnical: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/' + vm.data.id + '/review/technical', vm.data)
						.then(function (response) {
							vm.$toastr.success('Provider Review Technical updated.');
						})
						.catch(e => {
							vm.errors.record(e.response.data);
							vm.$toastr.error('Save Provider Review Technical changes failed.', 'Error');
						});
			}
		}
	}
</script>

<style scoped>

</style>
